// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__3mmBd","signatureButtonsRight":"ModalSign_signatureButtonsRight__12Wk-"};